import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import AnalyticsAPI from "../serviceAPI/AnalyticsAPI";

const initialState = {
  isLoading: false,
  errorCode: null,
  analyticsData: {},
};

export const getUserbasedAnalytics = createAsyncThunk(
  "getUserbasedAnalytics",
  async (data, { rejectWithValue }) => {
    try {
      const res = await AnalyticsAPI.PostUserBasedAnalytics(data);
      return res;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  }
);

export const getVisitbasedAnalytics = createAsyncThunk(
  "getVisitbasedAnalytics",
  async (data, { rejectWithValue }) => {
    try {
      const res = await AnalyticsAPI.PostVisitBasedAnalytics(data);
      return res;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  }
);

const AnalyticsSlice = createSlice({
  name: "analytics",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getUserbasedAnalytics.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getUserbasedAnalytics.fulfilled, (state, action) => {
        state.isLoading = false;
        // MERGE new user analytics data into existing analyticsData state
        state.analyticsData = {
          ...state.analyticsData,
          ...action.payload,
        };
      })
      .addCase(getUserbasedAnalytics.rejected, (state, action) => {
        state.isLoading = false;
        state.errorCode = action.payload;
      })

      .addCase(getVisitbasedAnalytics.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getVisitbasedAnalytics.fulfilled, (state, action) => {
        state.isLoading = false;
        // Add visit-based analytics to analyticsData without overwriting existing data
        state.analyticsData = {
          ...state.analyticsData,
          visitBasedAnalytics: action.payload,
        };
      })
      .addCase(getVisitbasedAnalytics.rejected, (state, action) => {
        state.isLoading = false;
        state.errorCode = action.payload;
      });
  },
  reducers: {
    clearAnalytics: (state) => {
      state.analyticsData = {};
      state.errorCode = null;
      state.isLoading = false;
    },
  },
});

export const { clearAnalytics } = AnalyticsSlice.actions;
export default AnalyticsSlice.reducer;